<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <v-container>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>Contact Data</v-toolbar-title>
        </v-toolbar>
        <v-row dense>
            <v-col :cols="12">
                <ValidationProvider v-if="requireFields"
                    mode="aggressive"
                    rules="requiredEmail|email"
                    :debounce="300"
                    v-slot="{ errors }">
                    <v-text-field
                        v-model="email"
                        label="Email Address *"
                        :error-messages=errors[0]>
                    </v-text-field>
                </ValidationProvider>
                <ValidationProvider v-else
                    mode="aggressive"
                    rules="email"
                    :debounce="300"
                    v-slot="{ errors }">
                    <v-text-field
                        v-model="email"
                        label="Email Address"
                        :error-messages=errors[0]>
                    </v-text-field>
                </ValidationProvider>
            </v-col>
            <v-col :cols="12">
                <v-text-field
                    v-model="phone"
                    label="Phone Number">
                </v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex'
    import { ValidationProvider, extend } from 'vee-validate';
    import {email, required} from 'vee-validate/dist/rules';

    extend('requiredEmail',
    {
        ...required,
        message: 'A valid email address is required.'
    });
    extend('email',
    {
        ...email,
        message: 'A valid email address is required.'
    });

    export default
    {
        name: 'patient-data-contact-info',
        components:
        {
            ValidationProvider
        },
        props:
        {
            requireFields: Boolean(false)
        },
        computed:
        {
            ...mapState('tests',
            {
                patientDataToMutate: state => state.patientDataToMutate
            }),
            email:
            {
                get: function ()
                {
                    return this.patientDataToMutate.contactInfo.emailAddress
                },
                set: function (newValue)
                {
                    this.patientDataToMutate.contactInfo.emailAddress = newValue
                }
            },
            phone:
            {
                get: function ()
                {
                    return this.patientDataToMutate.contactInfo.phoneNumber
                },
                set: function (newValue)
                {
                    this.patientDataToMutate.contactInfo.phoneNumber = newValue
                }
            }
        }
    };
</script>

<style scoped>
</style>